import React from "react";

const TimeLineCircle = ({ className, ...otherProps }) => (
  <div className={"circle-outline " + className} {...otherProps} />
);

export default function ActivityTimeLineCircle({ type, ...otherProps }) {
  return <TimeLineCircle className={`circle-${type}`} {...otherProps} />;
}
